// Facilities icons (from Facilities_all_icons)
import { ReactComponent as ALaCarteBreakfastIcon } from 'assets/image/svg/A_la_carte_breakfast.svg';
import { ReactComponent as AdultOnlyIcon } from 'assets/image/svg/Adult-only.svg';
import { ReactComponent as AirportTransferIcon } from 'assets/image/svg/Airport_transfer.svg';
import { ReactComponent as AsianCuisineIcon } from 'assets/image/svg/Asian_cuisine.svg';
import { ReactComponent as BadmintonCourtIcon } from 'assets/image/svg/Badminton_court.svg';
import { ReactComponent as BarIcon } from 'assets/image/svg/Bar.svg';
import { ReactComponent as BathroomIcon } from 'assets/image/svg/bathroom.svg';
import { ReactComponent as BathtubIcon } from 'assets/image/svg/bathtub.svg';
import { ReactComponent as BbqFacilitiesIcon } from 'assets/image/svg/BBQ_facilities.svg';
import { ReactComponent as BreakfastBuffetIcon } from 'assets/image/svg/Breakfast_buffet.svg';
import { ReactComponent as BreakfastContinentalIcon } from 'assets/image/svg/Breakfast_continental.svg';
import { ReactComponent as BreakfastFreeIcon } from 'assets/image/svg/Breakfast_free.svg';
import { ReactComponent as BreakfastIcon } from 'assets/image/svg/breakfast.svg';
import { ReactComponent as BreakfastServiceIcon } from 'assets/image/svg/Breakfast_service.svg';
import { ReactComponent as CarParkIcon } from 'assets/image/svg/Car_park.svg';
import { ReactComponent as CatFriendlyIcon } from 'assets/image/svg/Cat_friendly.svg';
import { ReactComponent as CityViewIcon } from 'assets/image/svg/city-view.svg';
import { ReactComponent as CoffeeShopIcon } from 'assets/image/svg/Coffee_shop.svg';
import { ReactComponent as ComputerStationIcon } from 'assets/image/svg/Computer_station.svg';
import { ReactComponent as CribIcon } from 'assets/image/svg/crib.svg';
import { ReactComponent as DogFriendlyIcon } from 'assets/image/svg/Dog_friendly.svg';
import { ReactComponent as DisabledIcon } from 'assets/image/svg/disabled.svg';
import { ReactComponent as EcarChargerIcon } from 'assets/image/svg/ecar-charger.svg';
import { ReactComponent as FreeBottledIcon } from 'assets/image/svg/Free_bottled.svg';
import { ReactComponent as FreeLaundryIcon } from 'assets/image/svg/Free_laundry.svg';
import { ReactComponent as FreeUseBusinessIcon } from 'assets/image/svg/Free_use_Business.svg';
import { ReactComponent as GardenViewIcon } from 'assets/image/svg/garden-view.svg';
import { ReactComponent as GiftSouvenirShopIcon } from 'assets/image/svg/Gift_souvenir_shop.svg';
import { ReactComponent as GymFitnessIcon } from 'assets/image/svg/Gym_fitness.svg';
import { ReactComponent as HappyHourIcon } from 'assets/image/svg/Happy_hour.svg';
import { ReactComponent as HotTubIcon } from 'assets/image/svg/Hot_tub.svg';
import { ReactComponent as InternetIcon } from 'assets/image/svg/Internet.svg';
import { ReactComponent as KidsClubIcon } from 'assets/image/svg/Kids_club.svg';
import { ReactComponent as KidsIcon } from 'assets/image/svg/kids.svg';
import { ReactComponent as LaundryServiceIcon } from 'assets/image/svg/Laundry_service.svg';
import { ReactComponent as MassageIcon } from 'assets/image/svg/Massage.svg';
import { ReactComponent as MiniGolfCourseIcon } from 'assets/image/svg/Mini_golf_course.svg';
import { ReactComponent as MinibarIcon } from 'assets/image/svg/minibar.svg';
import { ReactComponent as NonSmokingIcon } from 'assets/image/svg/non-smoking.svg';
import { ReactComponent as PetsAllowedIcon } from 'assets/image/svg/Pets_allowed.svg';
import { ReactComponent as PetIcon } from 'assets/image/svg/pet.svg';
import { ReactComponent as PlaygroundIcon } from 'assets/image/svg/Playground.svg';
import { ReactComponent as PoolsideBarIcon } from 'assets/image/svg/Poolside_bar.svg';
import { ReactComponent as PrivateBeachIcon } from 'assets/image/svg/Private_beach.svg';
import { ReactComponent as RestaurantsIcon } from 'assets/image/svg/Restaurants.svg';
import { ReactComponent as RoomServiceIcon } from 'assets/image/svg/Room_service.svg';
import { ReactComponent as SaunaIcon } from 'assets/image/svg/Sauna.svg';
import { ReactComponent as ShareKitchenIcon } from 'assets/image/svg/Share_kitchen.svg';
import { ReactComponent as ShopsIcon } from 'assets/image/svg/Shops.svg';
import { ReactComponent as SnackBarIcon } from 'assets/image/svg/Snack_bar.svg';
import { ReactComponent as SpaIcon } from 'assets/image/svg/spa.svg';
import { ReactComponent as SpaSaunaIcon } from 'assets/image/svg/Spa_sauna.svg';
import { ReactComponent as SteamroomIcon } from 'assets/image/svg/Steamroom.svg';
import { ReactComponent as SwimmingPoolDirectAccessIcon } from 'assets/image/svg/Swimming_pool_direct_access.svg';
import { ReactComponent as SwimmingPoolIcon } from 'assets/image/svg/Swimming_pool.svg';
import { ReactComponent as SwimmingPoolIndoorIcon } from 'assets/image/svg/Swimming_pool_indoor.svg';
import { ReactComponent as SwimmingPoolKidIcon } from 'assets/image/svg/Swimming_pool_kid.svg';
import { ReactComponent as SwimmingPoolOutdoorIcon } from 'assets/image/svg/Swimming_pool_outdoor.svg';
import { ReactComponent as TVIcon } from 'assets/image/svg/tv.svg';
import { ReactComponent as ValetParkingIcon } from 'assets/image/svg/Valet_parking.svg';
import { ReactComponent as WesternBreakfastIcon } from 'assets/image/svg/Western_breakfast.svg';
import { ReactComponent as WiFiChargesIcon } from 'assets/image/svg/Wi-fi_charges.svg';
import { ReactComponent as WiFiPublicIcon } from 'assets/image/svg/Wi-Fi_public.svg';
import { ReactComponent as WifiFreeIcon } from 'assets/image/svg/Wifi_free.svg';
import { ReactComponent as WithViewIcon } from 'assets/image/svg/with-view.svg';
import { ReactComponent as YogaRoomIcon } from 'assets/image/svg/Yoga_room.svg';
// Legacy icons (no Facilities equivalent)
import { ReactComponent as AllowedSmokingIcon } from 'assets/image/svg/allowed-smoking.svg';
import { ReactComponent as AirConditioningIcon } from 'assets/image/svg/air-conditioning.svg';
import { ReactComponent as BalconyIcon } from 'assets/image/svg/balcony.svg';
import { ReactComponent as SofaIcon } from 'assets/image/svg/sofa.svg';
import { ReactComponent as SoundproofIcon } from 'assets/image/svg/soundproof.svg';
import { ReactComponent as SkiIcon } from 'assets/image/svg/ski.svg';
import { ReactComponent as ShuttleIcon } from 'assets/image/svg/Shuttle_service.svg';
import { ReactComponent as ConciergeIcon } from 'assets/image/svg/Concierge.svg';
import hotelFacilitiesMapping from './hotelFacilitiesMapping.json';

export const processFacilities = (facilities?: string[]) => {
   const displayFacilites = hotelFacilitiesMapping.filter(f => f.display && f.display.trim() !== '');

   const mappedFacilites = facilities && facilities.length ? displayFacilites.filter(f => facilities?.includes(f.source)) : displayFacilites;

   const currentDisplays = new Set(mappedFacilites.map(f => f.display));

   return mappedFacilites.filter(f => !f.hideIf?.some(h => currentDisplays.has(h)));
};

export const kitchenHotelFacilities = ['Shared Kitchen', 'Free Breakfast'];

export const popularHotelFacilities = ['Free Breakfast', 'Swimming Pool', 'Fitness Center', 'Free Parking', 'Pets Allowed', 'Free Wi-Fi'];

export const hotelFacilites = processFacilities().map(f => f.display);

export const getFacilityIcon = (name: string) => {
   const t = name?.toLowerCase();

   // Transport & Transfer
   if (t.includes('airport') || t.includes('shuttle')) return ShuttleIcon;
   if (t.includes('valet')) return ValetParkingIcon;
   if (t.includes('parking') || t.includes('car park')) return CarParkIcon;
   if (t.includes('ecar') || t.includes('charging') || t.includes('car power')) return EcarChargerIcon;

   // Breakfast Variants
   if (t.includes('breakfast buffet')) return BreakfastBuffetIcon;
   if (t.includes('free breakfast')) return BreakfastFreeIcon;
   if (t.includes('continental breakfast')) return BreakfastContinentalIcon;
   if (t.includes('western breakfast')) return WesternBreakfastIcon;
   if (t.includes('breakfast service') || t.includes('restaurant breakfast')) return BreakfastServiceIcon;
   if (t.includes('a la carte breakfast')) return ALaCarteBreakfastIcon;
   if (t.includes('breakfast')) return BreakfastIcon;

   // Food & Drink
   if (t.includes('coffee shop')) return CoffeeShopIcon;
   if (t.includes('snack bar')) return SnackBarIcon;
   if (t.includes('poolside bar')) return PoolsideBarIcon;
   if (t.includes('bar') || t.includes('alcohol')) return BarIcon;
   if (t.includes('meal') || t.includes('dining')) return RestaurantsIcon;
   if (
      t.includes('restaurant') ||
      t.includes('a la carte') ||
      t.includes('buffet') ||
      t.includes('halal') ||
      t.includes('kosher') ||
      t.includes('salad') ||
      t.includes('soup') ||
      t.includes('cuisine')
   )
      return RestaurantsIcon;
   if (t.includes('room service')) return RoomServiceIcon;
   if (t.includes('mini bar')) return MinibarIcon;

   // Beverages & Water
   if (t.includes('free bottled water')) return FreeBottledIcon;

   // Internet & WiFi
   if (t.includes('wi-fi charges') || t.includes('wi-fi [charges]')) return WiFiChargesIcon;
   if (t.includes('free wi-fi') || t.includes('wifi free')) return WifiFreeIcon;
   if (t.includes('wi-fi public')) return WiFiPublicIcon;
   if (t.includes('wifi') || t.includes('wi-fi') || t.includes('internet')) return InternetIcon;

   // Fitness & Wellness
   if (t.includes('badminton')) return BadmintonCourtIcon;
   if (t.includes('yoga')) return YogaRoomIcon;
   if (t.includes('gym') || t.includes('fitness')) return GymFitnessIcon;
   if (t.includes('spa sauna') || t.includes('spa/sauna')) return SpaSaunaIcon;
   if (t.includes('massage')) return MassageIcon;
   if (t.includes('sauna')) return SaunaIcon;
   if (t.includes('steamroom') || t.includes('steam room')) return SteamroomIcon;
   if (t.includes('hot tub') || t.includes('jacuzzi')) return HotTubIcon;
   if (t.includes('spa')) return SpaIcon;

   // Water / Leisure
   if (t.includes('swimming pool indoor')) return SwimmingPoolIndoorIcon;
   if (t.includes('swimming pool outdoor')) return SwimmingPoolOutdoorIcon;
   if (t.includes('swimming pool direct')) return SwimmingPoolDirectAccessIcon;
   if (t.includes('swimming pool kid') || t.includes('kids pool')) return SwimmingPoolKidIcon;
   if (t.includes('swimming pool') || t.includes('pool facilities')) return SwimmingPoolIcon;
   if (t.includes('private beach')) return PrivateBeachIcon;
   if (t.includes('beach')) return PrivateBeachIcon;
   if (t.includes('golf')) return MiniGolfCourseIcon;
   if (t.includes('ski') || t.includes('skiing')) return SkiIcon;

   // Kids & Family
   if (t.includes('kids club')) return KidsClubIcon;
   if (t.includes('playground')) return PlaygroundIcon;
   if (t.includes('kids') || t.includes('child')) return KidsIcon;
   if (t.includes('crib') || t.includes('baby')) return CribIcon;

   // Room features
   if (t.includes('air conditioning') || t.includes('air-conditioning')) return AirConditioningIcon;
   if (t.includes('shared kitchen')) return ShareKitchenIcon;
   if (t.includes('kitchen')) return ShareKitchenIcon;
   if (t.includes('balcony')) return BalconyIcon;
   if (t.includes('sofa')) return SofaIcon;
   if (t.includes('tv') || t.includes('television')) return TVIcon;
   if (t.includes('soundproof')) return SoundproofIcon;

   // Bathroom
   if (t.includes('bathroom')) return BathroomIcon;
   if (t.includes('bathtub')) return BathtubIcon;

   // View & Outdoor
   if (t.includes('garden view') || t.includes('garden')) return GardenViewIcon;
   if (t.includes('city view') || t.includes('city')) return CityViewIcon;
   if (t.includes('view')) return WithViewIcon;

   // Accessibility & Services
   if (t.includes('disabled') || t.includes('accessible') || t.includes('accessibility')) return DisabledIcon;
   if (t.includes('business center')) return FreeUseBusinessIcon;
   if (t.includes('computer') || t.includes('xerox') || t.includes('business')) return ComputerStationIcon;

   // Pets
   if (t.includes('cat-friendly') || t.includes('cat friendly')) return CatFriendlyIcon;
   if (t.includes('dog-friendly') || t.includes('dog friendly')) return DogFriendlyIcon;
   if (t.includes('pets allowed')) return PetsAllowedIcon;
   if (t.includes('pet-friendly')) return PetsAllowedIcon;
   if (t.includes('pet')) return PetIcon;

   // Laundry & Cleaning
   if (t.includes('free laundry')) return FreeLaundryIcon;
   if (t.includes('laundry')) return LaundryServiceIcon;

   // Smoking
   if (t.includes('non-smoking')) return NonSmokingIcon;
   if (t.includes('smoking allowed')) return AllowedSmokingIcon;

   // Entertainment & Activities
   if (t.includes('bbq') || t.includes('barbecue')) return BbqFacilitiesIcon;
   if (t.includes('happy hour')) return HappyHourIcon;
   if (t.includes('shops') || t.includes('shop')) return ShopsIcon;
   if (t.includes('gift shop') || t.includes('souvenir')) return GiftSouvenirShopIcon;

   // Special Accommodations
   if (t.includes('adult only')) return AdultOnlyIcon;
   if (t.includes('asian cuisine')) return AsianCuisineIcon;

   if (t.includes('concierge')) return ConciergeIcon;

   return FreeUseBusinessIcon; // fallback
};

export const getBenefitIcon = (benefit: string) => {
   const t = benefit?.toLowerCase() || '';

   // Food / Drinks - Meals
   if (t.includes('breakfast')) return BreakfastIcon;
   if (t.includes('iftar') || t.includes('suhur')) return RestaurantsIcon;
   if (t.includes('hot pot')) return RestaurantsIcon;
   if (t.includes('buffet dinner') || t.includes('buffet credit')) return RestaurantsIcon;
   if (
      t.includes('cruise dinner') ||
      t.includes('private dinner') ||
      t.includes('wagyu dinner') ||
      t.includes('shrimp dinner') ||
      t.includes('crab dinner')
   )
      return RestaurantsIcon;
   if (t.includes('japanese dinner') || t.includes('kaiseki dinner') || t.includes('western dinner') || t.includes('vegetarian dinner'))
      return RestaurantsIcon;
   if (t.includes('lunch') || t.includes('dinner')) return RestaurantsIcon;
   if (t.includes('meal plan') || t.includes('dining')) return RestaurantsIcon;
   if (t.includes('food delivery')) return RestaurantsIcon;
   if (t.includes('kids menu')) return KidsIcon;
   if (t.includes('mooncake') || t.includes('snacks') || t.includes('fruit basket')) return RestaurantsIcon;
   if (
      t.includes('vegetarian') ||
      t.includes('vegan') ||
      t.includes('halal') ||
      t.includes('kosher') ||
      t.includes('gluten-free') ||
      t.includes('keto')
   )
      return RestaurantsIcon;

   // Drinks / Bar
   if (t.includes('coffee') || t.includes('espresso')) return CoffeeShopIcon;
   if (t.includes('afternoon tea')) return CoffeeShopIcon;
   if (t.includes('mini bar')) return MinibarIcon;
   if (t.includes('open bar')) return BarIcon;
   if (t.includes('alcoholic')) return BarIcon;
   if (t.includes('wine')) return BarIcon;
   if (t.includes('welcome drink')) return BarIcon;
   if (t.includes('soft drinks') || t.includes('beverage')) return BarIcon;
   if (t.includes('bottled water')) return FreeBottledIcon;

   // Wellness
   if (t.includes('hot spring')) return HotTubIcon;
   if (t.includes('yoga')) return YogaRoomIcon;
   if (t.includes('massage')) return MassageIcon;
   if (t.includes('sauna')) return SaunaIcon;
   if (t.includes('spa')) return SpaIcon;
   if (t.includes('gym')) return GymFitnessIcon;

   // Transport
   if (t.includes('transfer') || t.includes('shuttle')) return ShuttleIcon;
   if (t.includes('airport')) return AirportTransferIcon;
   if (t.includes('parking')) return CarParkIcon;
   if (t.includes('car rental') || t.includes('bike rental') || t.includes('motorcycle')) return CarParkIcon;
   if (t.includes('transit') || t.includes('ferry')) return AirportTransferIcon;

   // Internet / Tech
   if (t.includes('wi-fi') || t.includes('wifi') || t.includes('internet')) return WifiFreeIcon;
   if (t.includes('sim card')) return InternetIcon;
   if (t.includes('tv') || t.includes('cable')) return TVIcon;

   // Entertainment / Activities
   if (t.includes('water park') || t.includes('waterpark')) return SwimmingPoolIcon;
   if (t.includes('pool')) return SwimmingPoolIcon;
   if (t.includes('theme park')) return KidsClubIcon;
   if (
      t.includes('cruise') ||
      t.includes('island tour') ||
      t.includes('safari') ||
      t.includes('snorkeling') ||
      t.includes('diving') ||
      t.includes('fishing') ||
      t.includes('watersports') ||
      t.includes('excursion')
   )
      return PrivateBeachIcon;
   if (t.includes('ski')) return SkiIcon;
   if (t.includes('golf')) return MiniGolfCourseIcon;
   if (t.includes('show tickets') || t.includes('tickets')) return ShopsIcon;
   if (t.includes('casino')) return GiftSouvenirShopIcon;
   if (t.includes('gaming') || t.includes('recreation')) return KidsClubIcon;
   if (t.includes('day use') || t.includes('resort')) return PrivateBeachIcon;

   // Credits / Discounts
   if (t.includes('gift card') || t.includes('gift basket')) return GiftSouvenirShopIcon;
   if (t.includes('welcome gift') || t.includes('anniversary gift') || t.includes('free gift')) return GiftSouvenirShopIcon;
   if (t.includes('credit') || t.includes('discount') || t.includes('duty-free')) return ShopsIcon;

   // VIP / Premium
   if (t.includes('upgrade')) return FreeUseBusinessIcon;
   if (t.includes('lounge') || t.includes('vip')) return FreeUseBusinessIcon;
   if (t.includes('late checkout') || t.includes('late checkin') || t.includes('early checkin')) return FreeUseBusinessIcon;
   if (t.includes('free night') || t.includes('extra bed') || t.includes('complimentary')) return FreeUseBusinessIcon;
   if (t.includes('robe')) return FreeUseBusinessIcon;

   // Health / COVID
   if (
      t.includes('pcr test') ||
      t.includes('covid test') ||
      t.includes('medical') ||
      t.includes('masks') ||
      t.includes('sanitizer') ||
      t.includes('room sanitizing')
   )
      return FreeUseBusinessIcon;
   if (t.includes('telemedicine')) return ComputerStationIcon;
   if (t.includes('housekeeping') || t.includes('laundry')) return LaundryServiceIcon;

   // Workspace / Other
   if (t.includes('meeting room')) return ComputerStationIcon;
   if (t.includes('phone')) return ComputerStationIcon;
   if (t.includes('basic room') || t.includes('amenities') || t.includes('payment options')) return FreeUseBusinessIcon;

   return FreeUseBusinessIcon; // fallback
};

export const mealBenefits = [
   'Breakfast',
   'Lunch',
   'Dinner',
   'Beverages',
   'Buffet Breakfast',
   'Buffet Dinner',
   'Buffet Credit',
   'Local Breakfast',
   'Vegetarian Breakfast',
   'Vegetarian Dinner',
   'Japanese Dinner',
   'Kaiseki Dinner',
   'Western Dinner',
   'Cruise Dinner',
   'Private Dinner',
   'Wagyu Dinner',
   'Shrimp Dinner',
   'Crab Dinner',
   'Hot Pot',
   'Iftar',
   'Suhur',
   'Meal Plan',
];

export const amenityMappingText: Record<string, string> = {
   Transfer: 'Shuttle',
};

export const starsDefault = [0, 1, 2, 3, 4, 5];

export const mainRoomAmenities = {
   'child-bed': CribIcon,
   'non-smoking': NonSmokingIcon,
   jacuzzi: HotTubIcon,
   'private-bathroom': BathroomIcon,
   kitchen: ShareKitchenIcon,
   smoking: AllowedSmokingIcon,
   'wi-fi': WifiFreeIcon,
};

export const kitchenRoomAmenities = ['fridge', 'tea-or-coffee', 'tea', 'dishwasher', 'kitchen-stuff', 'barbecue', 'Microwave', 'coffee'];

export const bathroomAmenities = ['towels', 'bath', 'shower', 'washing-machine', 'hairdryer', 'bathrobe'];

export interface CategorizedImage {
   url: string;
   category: string;
}

/**
 * Categorize images based on URL or filename patterns
 * Default: split into Bedroom, Bathroom, Living Area, etc.
 */
export const categorizeImages = (images: any[]): CategorizedImage[] => {
   if (!images || images.length === 0) return [];

   const imageCategories = ['Bedroom', 'Bathroom', 'Living Area', 'Dining', 'Facilities'];

   return images.map((img, idx) => {
      const url = typeof img === 'string' ? img : (img?.url || img?.image_url || img?.picture_url || '');

      // Simple categorization: assign based on order (cycling through categories)
      // Can be enhanced if images have metadata like image_type, description, etc.
      const category = imageCategories[idx % imageCategories.length];

      return {
         url,
         category,
      };
   });
};
